import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Card, Input, Select, Typography, useInput, useSelect } from '@chilecompra/react-kit/components'
import { checkInputErrorRequired, formatDNI } from '@chilecompra/react-kit/utils'
import { SEARCH_FILTER_NAME, SEARCH_FILTER_RUT, SEARCH_TYPES } from '../../config/settings/constant'
import { useRecaptcha } from '../../modules/hooks/recaptcha'
import { onGetGoogleRecaptchaTokenThunk } from '../Recaptcha/Recaptcha.actions'
import { onSearchBuyerThunk } from '../SearchBuyer/SearchBuyer.actions'
import { Column, ColumnButton, Form, Row } from './SearchFilterSection.styles'

/**
 * The search filters section container.
 */
const SearchFilterSection = () => {
  const dispatch = useDispatch()
  const { searching } = useSelector(state => state.searchBuyer)
  const { executeRecaptcha } = useRecaptcha('buyer_search_engine')

  const {
    error: searchTypeError,
    value: searchTypeValue,
    onChange: handleSearchTypeChange
  } = useSelect({ initialValue: 2 })
  const {
    error: dniError,
    value: dniValue,
    onChange: handleDniChange
  } = useInput({
    errorCallbacks: [checkInputErrorRequired()],
    formatCallbacks: [formatDNI]
  })

  const {
    error: orgLegalNameError,
    value: orgLegalNameValue,
    onChange: handleOrgLegalNameChange
  } = useInput({ errorCallbacks: [checkInputErrorRequired()] })

  const handleSubmit = event => {
    event.preventDefault()
    dispatch(
      onGetGoogleRecaptchaTokenThunk({
        executeRecaptcha,
        onSuccessCallback: () =>
          dispatch(
            onSearchBuyerThunk({
              searchType: searchTypeValue,
              dni: dniValue,
              orgLegalName: orgLegalNameValue
            })
          )
      })
    )
  }

  const handleDropdownChange = event => {
    handleSearchTypeChange(event)
    handleDniChange('')
    handleOrgLegalNameChange('')
  }

  return (
    <Card color="default" elevation="1" padding="1.5rem">
      <Form onSubmit={handleSubmit}>
        <Row
          container
          alignItems={
            (searchTypeValue === SEARCH_FILTER_RUT && dniError) ||
            (searchTypeValue === SEARCH_FILTER_NAME && orgLegalNameError)
              ? 'center'
              : 'flex-end'
          }
          flexDirection="row"
          justifyContent="space-between"
          margin="0"
          spacing={1}
        >
          <Column container alignItems="flex-end" flexGrow={1} padding="0" lg={3} md={3} xs={12}>
            <Typography variant="caption" fontWeight="bold">
              Identificador
            </Typography>
            <Select
              error={searchTypeError}
              options={SEARCH_TYPES}
              value={searchTypeValue}
              onChange={handleDropdownChange}
            />
          </Column>
          <Column container alignItems="flex-end" flexGrow={1} padding="0" lg={40} md={7} xs={12}>
            {/* Search by RUT */}
            {searchTypeValue === SEARCH_FILTER_RUT && (
              <>
                <Typography variant="caption" fontWeight="bold">
                  Nombre o Razón social
                </Typography>
                <Input error={dniError} value={dniValue} onChange={handleDniChange} />
              </>
            )}
            {/* Search by organization's legal name */}
            {searchTypeValue === SEARCH_FILTER_NAME && (
              <>
                <Typography variant="caption" fontWeight="bold">
                  Nombre o Razón social
                </Typography>
                <Input
                  error={orgLegalNameError}
                  value={orgLegalNameValue}
                  onChange={handleOrgLegalNameChange}
                  autoFocus
                />
              </>
            )}
          </Column>
          <ColumnButton md={12} xs={12}>
            <Button color="primary" loading={searching} type="submit" width="auto" size="medium" disabled={searching}>
              Buscar
            </Button>
          </ColumnButton>
        </Row>
      </Form>
    </Card>
  )
}

export default SearchFilterSection
